import { render, staticRenderFns } from "./DecidedMasterThesis.vue?vue&type=template&id=486f0ee5&"
import script from "./DecidedMasterThesis.vue?vue&type=script&lang=js&"
export * from "./DecidedMasterThesis.vue?vue&type=script&lang=js&"
import style0 from "./DecidedMasterThesis.vue?vue&type=style&index=0&id=486f0ee5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports